var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OceanFreightSaleCard.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c450303a\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OceanFreightSaleCard.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/ulip/OceanFreightSaleCard.vue
// module id = 2269
// module chunks = 0